<template>
  <div class="product-list-page">
    <ais-instant-search-ssr :class-names="{ 'ais-InstantSearch': 'row' }">
      <ais-configure
        :hits-per-page.camel="$store.state.hitsPerPage"
        :filters="filters"
        :click-analytics.camel="false"
        :analytics-tags.camel="analyticsTags"
      />

      <!-- Since not all insight events automatically have a queryID
           we capture the queryID here so that it can be added to
           those events later
           TODO: this shouldn't be needed, default Algolia insight
           events should also automatically have a queryID -->
      <ais-state-results>
        <template #default="{ results: { queryID } }">
          {{ setQueryID(queryID) }}
        </template>
      </ais-state-results>

      <!-- Algolia widgets need be on the page for filtering to work
           we don't want to show a searchbox for now, as people would use
           the one in the header, so hide it with CSS -->
      <ais-search-box class="d-none" />

      <ais-refinement-list attribute="section_names" class="d-none" />

      <div id="sidebar-catalog-wrapper" class="col-md-4 col-lg-3">
        <CategoriesSidebar />

        <FiltersSidebar
          :open="isFilterSidebarOpen"
          :hide-store-filter="type === 'store'"
          :hide-brand-filter="type === 'brand'"
          @onClose="isFilterSidebarOpen = false"
        />
      </div>

      <CatalogProductOverview
        :subcategory-filter-slug="subcategoryFilterSlug"
        @openFilterSidebar="isFilterSidebarOpen = true"
        @setSubcategoryFilter="setSubcategoryFilter"
      />
    </ais-instant-search-ssr>
  </div>
</template>

<script>
import {
  AisInstantSearchSsr,
  AisConfigure,
  AisStateResults,
  AisSearchBox,
  AisRefinementList,
} from 'vue-instantsearch';
import CategoriesSidebar from './CategoriesSidebar.vue';
import FiltersSidebar from './FiltersSidebar.vue';
import CatalogProductOverview from './CatalogProductOverview.vue';

export default {
  components: {
    AisInstantSearchSsr,
    AisConfigure,
    AisStateResults,
    AisSearchBox,
    AisRefinementList,
    CategoriesSidebar,
    FiltersSidebar,
    CatalogProductOverview,
  },
  async beforeRouteUpdate(to, from, next) {
    await this.$store.dispatch('setCatalogContext', { path: to.path });

    if (typeof window === 'object') {
      // Update window title while navigating
      this.setWindowTitle();
    }

    next();
  },
  data() {
    // Because these are needed on multiple places
    // and this is the only way to get picked up
    // by django i18n makemessages
    this.$store.commit('setLabels', {
      FAT: this.gettext('FAT'),
      MIL: this.gettext('MIL'),
      LOCP: this.gettext('LOCP'),
      ANF: this.gettext('ANF'),
      SUPLC: this.gettext('SUPLC'),
    });
    this.$store.commit('setColors', {
      Black: this.gettext('Black'),
      Grey: this.gettext('Grey'),
      Blue: this.gettext('Blue'),
      Red: this.gettext('Red'),
      Pink: this.gettext('Pink'),
      Beige: this.gettext('Beige'),
      Purple: this.gettext('Purple'),
      Yellow: this.gettext('Yellow'),
      Green: this.gettext('Green'),
      White: this.gettext('White'),
      Brown: this.gettext('Brown'),
      Orange: this.gettext('Orange'),
      Denim: this.gettext('Denim'),
      'Other/Multi': this.gettext('Other/Multi'),
    });

    return {
      type: this.$route.name,
      section:
        this.$store.getters.sectionSlugToIdMap[this.$route.params.section],
      // section: this.$route.params.section,
      isFilterSidebarOpen: false,
      // A way to filter down products in a subcategory even more
      subcategoryFilterSlug: null,
      // All analytics events during this session will be given these tags
      analyticsTags: [
        `country_code_${this.$store.state.countryCode.toLowerCase()}`,
        `language_${this.$store.state.language.toLowerCase()}`,
      ],
    };
  },
  computed: {
    filters() {
      // Always filter on country code and if a product is visible
      let result = `country_site_codes:${this.$store.state.countryCode} && visible:true`;

      if (this.type === 'store') {
        // in store view, filter on store name
        result += ` && store_name:${this.$store.state.catalog.store.name}`;
      } else if (this.type === 'brand') {
        // in brand view, filter on brand name
        result += ` && brand_name:${this.$store.state.catalog.brand.name}`;
      } else if (this.type == 'image') {
        // in image result view, filter on product IDs
        if (this.$store.state.imageresults) {
          result += ` && product_id:[${this.$store.state.imageresults.join(
            ', '
          )}]`;
        }
      }

      // Custom filter on sub-subcategories (slug)
      if (this.subcategoryFilterSlug) {
        result += ` && subcategory_filter_slugs:${this.subcategoryFilterSlug}`;
      }

      return result;
    },
  },
  methods: {
    setQueryID(queryID) {
      this.$store.commit('setQueryID', queryID);
    },
    setWindowTitle() {
      let seo_title = `${this.$store.state.catalog.title} | Project Cece`;

      if (this.type == 'store') {
        seo_title = `${this.gettext('Sustainable clothing by')} ${
          this.$store.state.catalog.store.name
        } | Project Cece`;
      } else if (this.type === 'brand') {
        seo_title = `${this.$store.state.catalog.brand.name} ${this.gettext(
          '| Sustainable clothing brand'
        )} `;
      }
      window.document.title = seo_title;
    },
    setSubcategoryFilter(slug) {
      this.subcategoryFilterSlug = slug;
    },
  },
};
</script>
